import defaultTheme from './default';
import minimalTheme from './minimal';
import compactTheme from './compact';
import darkTheme from './dark';

const themes = {
  default: defaultTheme,
  minimal: minimalTheme,
  compact: compactTheme,
  dark: darkTheme,
};

export const getTheme = (themeName) => themes[themeName] || themes.default;
export const getAvailableThemes = () => Object.keys(themes);
export const getThemeDefaultHighlightColor = (themeName) => {
  const theme = themes[themeName] || themes.default;
  return theme.defaultHighlightColor || '#00d4ff';
};
